module.exports = __webpack_public_path__ + "static/media/personal-icon-active.ed0136c7.svg";